import React, { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const Search = ({view, popup}) => {
    const nodeRef = React.createRef(); // useRef(null);

    let search;
    useEffect(() => {
        const runEffect = async () => {
            loadModules(['esri/widgets/Search', 'esri/layers/FeatureLayer'], {css: true}).then(([Search, FeatureLayer]) => {
                search = new Search({
                    id: 'searchWidget',
                    view: view,
                    container: nodeRef.current,
                    // sources: [
                    //         {
                    //         layer: new FeatureLayer({
                    //             url: "",
                    //             outFields: ["*"]
                    //         }),
                    //         searchFields: ["scanname"],
                    //         displayField: "scanname",
                    //         exactMatch: false,
                    //         outFields: ["*"],
                    //         popupTemplate: popup,
                    //         name: "Scans",
                    //         placeholder: "search scan by number",
                    //         maxResults: 6,
                    //         maxSuggestions: 6,
                    //         suggestionsEnabled: true,
                    //         minSuggestCharacters: 0
                    //         }
                    //     ],
                    //     activeSourceIndex: 0
                });
            }).catch((err) => console.error(err));
        }
        runEffect();
        return () => {
            if (!!search) {
                search.container = null;
            }
        }
    }, [nodeRef.current]);

    return (
        <div id='search' ref={nodeRef}/>
    )  
}

export { Search };